import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-support-img-view',
  templateUrl: './support-img-view.page.html',
  styleUrls: ['./support-img-view.page.scss'],
})
export class SupportImgViewPage implements AfterViewInit {

  imgUrl: '';

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams
  ) { }

  ngAfterViewInit() {
    this.imgUrl = this.navParams.get('img');
    // console.log(this.imgUrl)
    setTimeout(() => {
      document.getElementById('chatImg').setAttribute('src', this.imgUrl);
    }, 1000);
  }

  downloadImg() {
    window.open(this.imgUrl, '_blank');
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
